import { Action, createReducer, on } from '@ngrx/store';
import { IDatiqFeatureFlag } from '../models';

import * as DatiqFeatureFlagActions from './datiq-feature-flag.actions';
import {
    datiqFeatureFlagAdapter,
    initialState,
    State,
} from './datiq-feature-flag.models';

const datiqFeatureFlagReducer = createReducer(
    initialState,
    on(
        DatiqFeatureFlagActions.setFeatureFlags,
        (state, { featureFlags }: { featureFlags: IDatiqFeatureFlag[] }) =>
            datiqFeatureFlagAdapter.upsertMany(featureFlags, {
                ...state,
                useFlags: true,
                loaded: true,
            }),
    ),
    on(DatiqFeatureFlagActions.unuseFeatureFlags, (state) => ({
        ...state,
        useFlags: false,
        loaded: true,
    })),
    on(
        DatiqFeatureFlagActions.enorlledExperimentFlag,
        (state, { flag }: { flag: IDatiqFeatureFlag }) =>
            datiqFeatureFlagAdapter.upsertOne(flag, {
                ...state,
                loaded: true,
                useFlags: true,
            }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return datiqFeatureFlagReducer(state, action);
}
